/**
 * Build-time configuration for user-facing limits.
 *
 * Vite inlines `import.meta.env.*` at build time. Keep
 * `VITE_MAX_QUESTION_LENGTH` in sync with the edge function's
 * `MAX_QUESTION_LENGTH` (both default to 1000).
 */

function positiveInt(value: unknown, fallback: number): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed > 0 ? Math.floor(parsed) : fallback;
}

/** Maximum characters in a single question. */
export const MAX_QUESTION_LENGTH = positiveInt(
  import.meta.env.VITE_MAX_QUESTION_LENGTH,
  1000,
);

/** Show the character counter from this many characters onward (80%). */
export const QUESTION_COUNT_WARN_AT = Math.floor(MAX_QUESTION_LENGTH * 0.8);

/** Whether the counter should be visible for a value of `length`. */
export function shouldShowCharCount(length: number): boolean {
  return length >= QUESTION_COUNT_WARN_AT;
}

/**
 * Where "support this project" links point (Ko-fi). Overridable so a fork can
 * point at its own page without touching code.
 */
export const SUPPORT_URL = import.meta.env.VITE_SUPPORT_URL ??
  "https://ko-fi.com/fabaijudge";
